import React, { useEffect, useState } from "react";
import { Modal } from "react-fast-ui";

import SUCCESS_CHECKMARK from "../../res/success-checkmark.svg";
import upgradeImage from "../../res/upgrade-to-bundle.png";
import LoadingDiv from "./layout/LoadingDiv";
import AdminButton from "./layout/AdminButton";

const UpgradeConsumerModal = ({
  dao,
  open,
  onClose,
  upgradeLink,
  payload,
  logout,
}) => {
  // Initialize the loading state
  const [showLoader, setShowLoader] = useState(false);
  const [hasAttemptedUpgrade, setHasAttemptedUpgrade] = useState(false);
  const [didSucceed, setDidSucceed] = useState(false);

  const [upgradeApiMessage, setUpgradeApiMessage] = useState(false);
  const [countdown, setCountdown] = useState(20);

  useEffect(() => {
    let timer;
    if (didSucceed) {
      timer = setInterval(() => {
        setCountdown((prevCount) => {
          if (prevCount <= 1) {
            clearInterval(timer);
            logout(); // Trigger logout when countdown reaches 0
            return 0;
          }
          return prevCount - 1;
        });
      }, 1000);
    }

    return () => clearInterval(timer);
  }, [didSucceed]);

  const getCurrentDateOnNextYear = () => {
    const currentDate = new Date();

    currentDate.setFullYear(currentDate.getFullYear() + 1);

    // Format the date to be more readable, for example, 'Month Day, Year'
    const options = { year: "numeric", month: "long", day: "numeric" };
    return currentDate.toLocaleDateString(undefined, options);
  };

  const handleUpgradeSelection = (offer) => {
    setShowLoader(true); // Set loading state to true when upgrade starts
    try {
      dao.account
        .upgradeSubscription(offer.sku, offer.externalVariantId)
        .then((res) => {
          console.log(res);
          setUpgradeApiMessage(res.message);
          setDidSucceed(res.status !== "error");
          setHasAttemptedUpgrade(true);
          setShowLoader(false); // Stop loading
        })
        .catch((error) => {
          console.error(error);
          setUpgradeApiMessage(
            error.message || "An error occurred during upgrade."
          );
          setDidSucceed(false);
          setHasAttemptedUpgrade(true);
          setShowLoader(false); // Stop loading
        });
    } catch (error) {
      console.error(error);
      setShowLoader(false); // Ensure loading state is reset on exception
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Body
        style={{
          padding: "0",
          paddingTop: "20px",
          display: "flex",
          flexDirection: "column",
          height: "100%",

          borderTop: hasAttemptedUpgrade
            ? didSucceed
              ? "6px solid rgb(43, 182, 115)"
              : "6px solid #f9b743"
            : "6px solid #13c3ff",
        }}
      >
        {
          showLoader ? (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingBottom: "100px",
              }}
            >
              <LoadingDiv>Upgrading</LoadingDiv>
              <p>Upgrading! This will take a few seconds.</p>
            </div>
          ) : hasAttemptedUpgrade ? (
            <div className="splash-screen">
              <div className="upgrade-message-icon">
                {didSucceed ? (
                  <img style={{ width: "100px" }} src={SUCCESS_CHECKMARK} />
                ) : (
                  <i
                    style={{ color: "#f9b743", fontSize: "68px" }}
                    className="fa fa-warning"
                  />
                )}
              </div>
              <p style={{ textAlign: "center" }}>
                {upgradeApiMessage || "Thank you for upgrading!"}
              </p>
              {didSucceed ? (
                <div>
                  <p style={{ paddingBottom: "6px", textAlign: "center" }}>
                    Signing out in {countdown} second{countdown > 1 ? "s" : ""}
                  </p>
                  <AdminButton
                    onClick={() => session.logout()}
                    style={{
                      color: "white",
                      backgroundColor: "rgb(43, 182, 115)",
                    }}
                  >
                    Sign out now
                  </AdminButton>
                </div>
              ) : (
                <AdminButton
                  onClick={() =>
                    window.open(
                      "mailto:sales@fastmodelsports.com?subject=Assistance%20Required-Upgrade&body=I%20am%20writing%20to%20request%20assistance%20with%20upgrading%20my%20account."
                    )
                  }
                  style={{
                    color: "white",
                    backgroundColor: "#f9b743",
                  }}
                >
                  Contact Support
                </AdminButton>
              )}
            </div>
          ) : (
            <div
              style={{
                width: "100%",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <div className="upgrade-container" style={{ width: "100%" }}>
                <div className="sparkle"></div>
                <div className="sparkle red"></div>
                <div className="sparkle blue"></div>
                <div className="upgrade-heading">
                  <h1>Upgrade to a Bundle</h1>
                  <h1>Limited time discount of 20% off your upgrade</h1>
                  <p>Empower your team with these additional features</p>
                </div>

                <div className="upgrade-body">
                  <div className="upgrade-img">
                    <img
                      className="image-with-reflection"
                      src={upgradeImage}
                      alt="Upgrade to Bundle"
                    />
                  </div>
                  <div className="upgrade-text">
                    <ul>
                      <li>Tailored Scouting Reports and Practice Plans</li>
                      <li>AI-Powered Quizzes for Improved Retention</li>
                      <li>
                        Unified Platform for Game Preparation, Including Video
                        Integration
                      </li>
                      <li>
                        Modeled After Strategies Used by Elite Programs and
                        Professional Teams
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  className="offer-list"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    flexWrap: "wrap",
                    // gap: '10px',
                    paddingBottom: "20px",
                    justifyContent: "space-evenly",
                  }}
                >
                  {payload?.offers?.map((offer, index) => (
                    <div key={index} className="offer-container">
                      <div>
                        <h2 className="offer-title">{offer.productName}</h2>
                        <p className="offer-description">{offer.description}</p>
                      </div>

                      <div className="offer-items">
                        <p className="offer-items-label">
                          {offer.offerItemsLabel}
                        </p>
                        {offer.offerItems.map((item) => (
                          <span style={{ display: "flex" }}>
                            <span
                              style={{ fontSize: "16px", fontWeight: "bold" }}
                            >
                              <i
                                className="fa fa-check-circle"
                                style={{
                                  paddingRight: "2px",
                                  color: "rgb(49, 130, 206)",
                                }}
                              ></i>
                            </span>
                            <span
                              style={{ fontSize: "14px", flexWrap: "wrap" }}
                            >
                              {item}
                            </span>
                          </span>
                        ))}
                      </div>

                      <div>
                        <p className="offer-price">
                          <span>Price:</span>
                          <span className="original-price">
                            {offer.originalPriceFormatted}
                          </span>
                        </p>
                        <p className="offer-discount">
                          <span>
                            20% Off: (-{offer.discountedAmountFormatted})
                          </span>
                          <span className="original-price">
                            {offer.discountedPriceFormatted}
                          </span>
                        </p>
                        <p className="offer-credit">
                          <span>
                            Credit Applied: (-{offer.creditedAmountFormatted})
                          </span>
                          <span className="final-price">
                            {offer.discountedAndCreditedPriceFormatted}
                          </span>
                        </p>
                        <AdminButton
                          onClick={() => handleUpgradeSelection(offer)}
                          className="upgrade-button"
                          style={{
                            marginTop: "10px",
                            backgroundColor: "#3182ce",
                            color: "#fff",
                          }}
                        >
                          Upgrade Now for{" "}
                          {offer.discountedAndCreditedPriceFormatted}
                        </AdminButton>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="upgrade-footer" style={{ textAlign: "center" }}>
                <p>
                  The discounted price is applicable for this subscription
                  period. Please note that upon renewal on{" "}
                  {getCurrentDateOnNextYear()}, the original price will be
                  charged. Your current card on file will be billed. To use
                  another card, kindly update your payment details via the
                  customer portal link provided below.
                </p>
                <div className="upgrade-link">
                  <AdminButton
                    onClick={() => window.open(upgradeLink, "_blank")}
                    style={{
                      marginTop: "10px",
                      backgroundColor: "#3182ce",
                      color: "#fff",
                      maxWidth: "200px",
                      margin: "auto",
                    }}
                  >
                    Portal
                  </AdminButton>
                </div>
              </div>
            </div>
          )
          // Normal modal content when not loading
        }
      </Modal.Body>
    </Modal>
  );
};

export default UpgradeConsumerModal;
